const tokens = {
  "colors.white": {
    "value": "#FFF",
    "variable": "var(--RiClf)"
  },
  "colors.black": {
    "value": "#000",
    "variable": "var(--qLIrn)"
  },
  "colors.transparent": {
    "value": "#FFFFFF00",
    "variable": "var(--edNtiq)"
  },
  "colors.light.100": {
    "value": "#E6E6E6",
    "variable": "var(--gcCerW)"
  },
  "colors.light.200": {
    "value": "#CCCCCC",
    "variable": "var(--hEiqGh)"
  },
  "colors.light.300": {
    "value": "#B3B3B3",
    "variable": "var(--jKPbeg)"
  },
  "colors.light.400": {
    "value": "#808080",
    "variable": "var(--fTTGyH)"
  },
  "colors.light.500": {
    "value": "#666666",
    "variable": "var(--iaAqWG)"
  },
  "colors.dark.100": {
    "value": "#4D4D4D",
    "variable": "var(--eupsbY)"
  },
  "colors.dark.200": {
    "value": "#333333",
    "variable": "var(--ELegn)"
  },
  "colors.dark.300": {
    "value": "#292929",
    "variable": "var(--hJiziu)"
  },
  "colors.dark.400": {
    "value": "#1F1F1F",
    "variable": "var(--RfAvF)"
  },
  "colors.dark.500": {
    "value": "#1A1A1A",
    "variable": "var(--hVCVxM)"
  },
  "colors.dark.600": {
    "value": "#141414",
    "variable": "var(--efYHCb)"
  },
  "colors.dark.700": {
    "value": "#010101",
    "variable": "var(--lkwcEi)"
  },
  "colors.red.100": {
    "value": "#E5674E",
    "variable": "var(--fKgVwH)"
  },
  "colors.red.200": {
    "value": "#DE6A43",
    "variable": "var(--bLdQLg)"
  },
  "colors.red.300": {
    "value": "#873120",
    "variable": "var(--fMUQaR)"
  },
  "colors.red.400": {
    "value": "#421810",
    "variable": "var(--hwCQam)"
  },
  "colors.red.500": {
    "value": "#3B150E",
    "variable": "var(--iYfRb)"
  },
  "colors.green.100": {
    "value": "#89C26E",
    "variable": "var(--iDDIAz)"
  },
  "colors.green.150": {
    "value": "#5AC655",
    "variable": "var(--xlzhi)"
  },
  "colors.green.200": {
    "value": "#479655",
    "variable": "var(--khfuXU)"
  },
  "colors.green.300": {
    "value": "#1E470B",
    "variable": "var(--hypAVx)"
  },
  "colors.green.400": {
    "value": "#2C3B32",
    "variable": "var(--wGfza)"
  },
  "colors.green.500": {
    "value": "#243029",
    "variable": "var(--jdlUVz)"
  },
  "colors.lilac.100": {
    "value": "#C7ABF5",
    "variable": "var(--cojwIP)"
  },
  "colors.lilac.200": {
    "value": "#9D88C0",
    "variable": "var(--hbNTWc)"
  },
  "colors.lilac.300": {
    "value": "#73658A",
    "variable": "var(--kfjcud)"
  },
  "colors.lilac.400": {
    "value": "#5A506A",
    "variable": "var(--dPiscm)"
  },
  "colors.lilac.500": {
    "value": "#38343F",
    "variable": "var(--gSDAAn)"
  },
  "colors.lilac.600": {
    "value": "#2F2C34",
    "variable": "var(--qMooE)"
  },
  "colors.blue.100": {
    "value": "#0D99D9",
    "variable": "var(--bYrJpO)"
  },
  "colors.brandYellow.100": {
    "value": "#FFFFCC",
    "variable": "var(--bEfhMD)"
  },
  "colors.brandYellow.200": {
    "value": "#FFFF99",
    "variable": "var(--iatcLc)"
  },
  "colors.brandYellow.300": {
    "value": "#FFFF66",
    "variable": "var(--bgxuzZ)"
  },
  "colors.brandYellow.400": {
    "value": "#FFFF33",
    "variable": "var(--jSeelK)"
  },
  "colors.brandYellow.500": {
    "value": "#FFF600",
    "variable": "var(--cYiwaH)"
  },
  "colors.brandYellow.550": {
    "value": "#CCFF00",
    "variable": "var(--ilkuyK)"
  },
  "colors.brandYellow.600": {
    "value": "#CCCC00",
    "variable": "var(--juwqZg)"
  },
  "colors.brandYellow.700": {
    "value": "#999900",
    "variable": "var(--cAAIOd)"
  },
  "colors.brandYellow.800": {
    "value": "#666600",
    "variable": "var(--cWmfPi)"
  },
  "colors.brandYellow.900": {
    "value": "#333300",
    "variable": "var(--hrMhdb)"
  },
  "colors.yellow.100": {
    "value": "#FFFDE8",
    "variable": "var(--kxGpio)"
  },
  "colors.yellow.200": {
    "value": "#FFF9C0",
    "variable": "var(--cbZZGT)"
  },
  "colors.yellow.300": {
    "value": "#FFF380",
    "variable": "var(--fwcFBW)"
  },
  "colors.yellow.400": {
    "value": "#FFE940",
    "variable": "var(--hUTJsd)"
  },
  "colors.yellow.500": {
    "value": "#FFE100",
    "variable": "var(--loWpng)"
  },
  "colors.yellow.600": {
    "value": "#D4BB00",
    "variable": "var(--cTpZLL)"
  },
  "colors.yellow.700": {
    "value": "#A89500",
    "variable": "var(--gnsFGO)"
  },
  "colors.yellow.800": {
    "value": "#7A6C00",
    "variable": "var(--ByZWN)"
  },
  "colors.yellow.900": {
    "value": "#4A4100",
    "variable": "var(--dVBFRQ)"
  },
  "colors.amber.100": {
    "value": "#FFF2CE",
    "variable": "var(--jZPQXp)"
  },
  "colors.amber.200": {
    "value": "#FFE59D",
    "variable": "var(--hCWpXC)"
  },
  "colors.amber.300": {
    "value": "#FFD86D",
    "variable": "var(--bCKrrD)"
  },
  "colors.amber.400": {
    "value": "#FFCB3C",
    "variable": "var(--wuHbc)"
  },
  "colors.amber.500": {
    "value": "#FFBE0B",
    "variable": "var(--fLErTZ)"
  },
  "colors.amber.600": {
    "value": "#B68500",
    "variable": "var(--doKQUm)"
  },
  "colors.amber.700": {
    "value": "#8B6601",
    "variable": "var(--iDUBNj)"
  },
  "colors.amber.800": {
    "value": "#523C02",
    "variable": "var(--iOnUJo)"
  },
  "colors.amber.900": {
    "value": "#332602",
    "variable": "var(--cObWdp)"
  },
  "colors.cream.100": {
    "value": "#F6F4F2",
    "variable": "var(--kCbVno)"
  },
  "colors.cream.200": {
    "value": "#EDE9E6",
    "variable": "var(--cJeWab)"
  },
  "colors.cream.300": {
    "value": "#E5DFD9",
    "variable": "var(--deaUzS)"
  },
  "colors.cream.400": {
    "value": "#DCD4CD",
    "variable": "var(--hnKSyN)"
  },
  "colors.cream.500": {
    "value": "#D3C9C0",
    "variable": "var(--hIGQYE)"
  },
  "colors.darkBrown.100": {
    "value": "#A9A19A",
    "variable": "var(--fVTBMy)"
  },
  "colors.darkBrown.200": {
    "value": "#7F7973",
    "variable": "var(--gAOBfV)"
  },
  "colors.darkBrown.300": {
    "value": "#54504D",
    "variable": "var(--jbsHqY)"
  },
  "colors.darkBrown.400": {
    "value": "#3B3733",
    "variable": "var(--jpCOkD)"
  },
  "colors.darkBrown.500": {
    "value": "#2E2B28",
    "variable": "var(--cLaPnq)"
  },
  "colors.darkBrown.600": {
    "value": "#211F1D",
    "variable": "var(--dpVOGN)"
  },
  "durations.0": {
    "value": "0s",
    "variable": "var(--ivLcTr)"
  },
  "durations.100": {
    "value": "0.2s",
    "variable": "var(--QbqAm)"
  },
  "durations.200": {
    "value": "0.4s",
    "variable": "var(--brQgdB)"
  },
  "durations.300": {
    "value": "0.6s",
    "variable": "var(--TSqVk)"
  },
  "durations.400": {
    "value": "0.8s",
    "variable": "var(--bYTGvn)"
  },
  "durations.500": {
    "value": "1.0s",
    "variable": "var(--bAVRmW)"
  },
  "fonts.sans": {
    "value": "var(--font-sans), sans-serif",
    "variable": "var(--dywXPJ)"
  },
  "fontSizes.10": {
    "value": "0.625rem",
    "variable": "var(--cknYZW)"
  },
  "fontSizes.11": {
    "value": "0.6875rem",
    "variable": "var(--gqsQnj)"
  },
  "fontSizes.12": {
    "value": "0.75rem",
    "variable": "var(--ikoYIM)"
  },
  "fontSizes.14": {
    "value": "0.875rem",
    "variable": "var(--bXGjqy)"
  },
  "fontSizes.16": {
    "value": "1rem",
    "variable": "var(--hXHiZo)"
  },
  "fontSizes.18": {
    "value": "1.125rem",
    "variable": "var(--bCxEOK)"
  },
  "fontSizes.20": {
    "value": "1.25rem",
    "variable": "var(--NNfFt)"
  },
  "fontSizes.24": {
    "value": "1.5rem",
    "variable": "var(--BfpVV)"
  },
  "fontSizes.28": {
    "value": "1.75rem",
    "variable": "var(--fWLuh)"
  },
  "fontSizes.32": {
    "value": "2rem",
    "variable": "var(--cZZCuC)"
  },
  "fontSizes.36": {
    "value": "2.25rem",
    "variable": "var(--cNrMLe)"
  },
  "fontSizes.40": {
    "value": "2.5rem",
    "variable": "var(--dTlMiP)"
  },
  "fontSizes.48": {
    "value": "3rem",
    "variable": "var(--dlvrXD)"
  },
  "fontSizes.52": {
    "value": "3.25rem",
    "variable": "var(--espmYc)"
  },
  "fontSizes.96": {
    "value": "6rem",
    "variable": "var(--dleXrE)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--fVSZDc)"
  },
  "fontWeights.regular": {
    "value": "390",
    "variable": "var(--TgeWs)"
  },
  "fontWeights.book": {
    "value": "440",
    "variable": "var(--kYNPVf)"
  },
  "fontWeights.medium": {
    "value": "480",
    "variable": "var(--leEsKL)"
  },
  "fontWeights.semibold": {
    "value": "570",
    "variable": "var(--hmvyHR)"
  },
  "fontWeights.bold": {
    "value": "660",
    "variable": "var(--ghWdwL)"
  },
  "fontWeights.black": {
    "value": "750",
    "variable": "var(--bvnjIx)"
  },
  "lineHeights.14": {
    "value": "0.875rem",
    "variable": "var(--giVcYh)"
  },
  "lineHeights.16": {
    "value": "1rem",
    "variable": "var(--ZAntH)"
  },
  "lineHeights.18": {
    "value": "1.125rem",
    "variable": "var(--opJXF)"
  },
  "lineHeights.20": {
    "value": "1.25rem",
    "variable": "var(--cALPIq)"
  },
  "lineHeights.24": {
    "value": "1.5rem",
    "variable": "var(--geTwe)"
  },
  "lineHeights.28": {
    "value": "1.75rem",
    "variable": "var(--fAVjUy)"
  },
  "lineHeights.32": {
    "value": "2rem",
    "variable": "var(--etbYot)"
  },
  "lineHeights.36": {
    "value": "2.25rem",
    "variable": "var(--bYvcch)"
  },
  "lineHeights.40": {
    "value": "2.5rem",
    "variable": "var(--bLbAPA)"
  },
  "lineHeights.44": {
    "value": "2.75rem",
    "variable": "var(--llatXM)"
  },
  "lineHeights.52": {
    "value": "3.25rem",
    "variable": "var(--iMmYuD)"
  },
  "lineHeights.64": {
    "value": "4rem",
    "variable": "var(--gduOgq)"
  },
  "lineHeights.112": {
    "value": "7rem",
    "variable": "var(--kfYmtC)"
  },
  "radii.0": {
    "value": "0px",
    "variable": "var(--kUJXSV)"
  },
  "radii.50": {
    "value": "2px",
    "variable": "var(--cbuAfw)"
  },
  "radii.100": {
    "value": "3px",
    "variable": "var(--gDEwJY)"
  },
  "radii.200": {
    "value": "4px",
    "variable": "var(--ksYUhH)"
  },
  "radii.250": {
    "value": "6px",
    "variable": "var(--hbeCmy)"
  },
  "radii.300": {
    "value": "8px",
    "variable": "var(--ccPOou)"
  },
  "radii.350": {
    "value": "12px",
    "variable": "var(--feNScH)"
  },
  "radii.400": {
    "value": "16px",
    "variable": "var(--cgcEXx)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--kkkBVq)"
  },
  "borderWidths.100": {
    "value": "1px",
    "variable": "var(--eyojOW)"
  },
  "borderWidths.200": {
    "value": "2px",
    "variable": "var(--kmVbEB)"
  },
  "shadows.light": {
    "value": "0 0 4px 4px #141414",
    "variable": "var(--gqVLiZ)"
  },
  "shadows.default": {
    "value": "0 2px 8px 10px rgba(0, 0, 0, 0.36)",
    "variable": "var(--bJVzvc)"
  },
  "sizes.0": {
    "value": "0px",
    "variable": "var(--kTdGYg)"
  },
  "sizes.1": {
    "value": "1px",
    "variable": "var(--cCUBeV)"
  },
  "sizes.2": {
    "value": "2px",
    "variable": "var(--gsUKim)"
  },
  "sizes.4": {
    "value": "4px",
    "variable": "var(--juMtMc)"
  },
  "sizes.8": {
    "value": "8px",
    "variable": "var(--cAmzCM)"
  },
  "sizes.12": {
    "value": "12px",
    "variable": "var(--ckODEv)"
  },
  "sizes.14": {
    "value": "14px",
    "variable": "var(--hTmzdp)"
  },
  "sizes.16": {
    "value": "16px",
    "variable": "var(--gANXGP)"
  },
  "sizes.20": {
    "value": "20px",
    "variable": "var(--htnoem)"
  },
  "sizes.24": {
    "value": "24px",
    "variable": "var(--tQYHK)"
  },
  "sizes.28": {
    "value": "28px",
    "variable": "var(--kcGldO)"
  },
  "sizes.32": {
    "value": "32px",
    "variable": "var(--gMkTEx)"
  },
  "sizes.40": {
    "value": "40px",
    "variable": "var(--kveXIc)"
  },
  "sizes.48": {
    "value": "48px",
    "variable": "var(--bPcliI)"
  },
  "sizes.56": {
    "value": "56px",
    "variable": "var(--hZfkST)"
  },
  "sizes.64": {
    "value": "64px",
    "variable": "var(--bSilTO)"
  },
  "sizes.72": {
    "value": "72px",
    "variable": "var(--fnTGst)"
  },
  "sizes.80": {
    "value": "80px",
    "variable": "var(--dAFdyM)"
  },
  "sizes.88": {
    "value": "88px",
    "variable": "var(--qOWrk)"
  },
  "sizes.96": {
    "value": "96px",
    "variable": "var(--jxszKr)"
  },
  "sizes.104": {
    "value": "104px",
    "variable": "var(--juwaTh)"
  },
  "sizes.112": {
    "value": "112px",
    "variable": "var(--enchku)"
  },
  "sizes.120": {
    "value": "120px",
    "variable": "var(--fjzEsL)"
  },
  "sizes.128": {
    "value": "128px",
    "variable": "var(--kNVzpj)"
  },
  "sizes.136": {
    "value": "136px",
    "variable": "var(--jnBLxo)"
  },
  "sizes.144": {
    "value": "144px",
    "variable": "var(--fewGQN)"
  },
  "sizes.152": {
    "value": "152px",
    "variable": "var(--iDbBmO)"
  },
  "sizes.160": {
    "value": "160px",
    "variable": "var(--jzyYvf)"
  },
  "sizes.176": {
    "value": "176px",
    "variable": "var(--eXCruU)"
  },
  "sizes.192": {
    "value": "192px",
    "variable": "var(--gWvejW)"
  },
  "sizes.208": {
    "value": "208px",
    "variable": "var(--eGYAqe)"
  },
  "sizes.224": {
    "value": "224px",
    "variable": "var(--iOGdjM)"
  },
  "sizes.240": {
    "value": "240px",
    "variable": "var(--dsBZwa)"
  },
  "sizes.256": {
    "value": "256px",
    "variable": "var(--jmamfl)"
  },
  "sizes.288": {
    "value": "288px",
    "variable": "var(--bXFDqC)"
  },
  "sizes.320": {
    "value": "320px",
    "variable": "var(--jKVUsN)"
  },
  "sizes.352": {
    "value": "352px",
    "variable": "var(--bNOODM)"
  },
  "sizes.384": {
    "value": "384px",
    "variable": "var(--hDGbcP)"
  },
  "sizes.400": {
    "value": "400px",
    "variable": "var(--ceuoXw)"
  },
  "sizes.416": {
    "value": "416px",
    "variable": "var(--kyUDtH)"
  },
  "sizes.432": {
    "value": "432px",
    "variable": "var(--gcoItp)"
  },
  "sizes.448": {
    "value": "448px",
    "variable": "var(--dGcuVA)"
  },
  "sizes.464": {
    "value": "464px",
    "variable": "var(--jOoPui)"
  },
  "sizes.480": {
    "value": "480px",
    "variable": "var(--eNNlWY)"
  },
  "sizes.512": {
    "value": "512px",
    "variable": "var(--cOKTYq)"
  },
  "sizes.544": {
    "value": "544px",
    "variable": "var(--dGftEJ)"
  },
  "sizes.prose": {
    "value": "65ch",
    "variable": "var(--jAesVz)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--khWApH)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--eOXrSu)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--jNBRbM)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--UhpHH)"
  },
  "sizes.breakpoint-xs": {
    "value": "24.375rem",
    "variable": "var(--jqgiFF)"
  },
  "sizes.breakpoint-sm": {
    "value": "37.5rem",
    "variable": "var(--eomHOU)"
  },
  "sizes.breakpoint-md": {
    "value": "56.25rem",
    "variable": "var(--iujnmj)"
  },
  "sizes.breakpoint-lg": {
    "value": "75rem",
    "variable": "var(--gThSgZ)"
  },
  "sizes.breakpoint-xl": {
    "value": "96rem",
    "variable": "var(--cssArG)"
  },
  "sizes.breakpoint-xxl": {
    "value": "120rem",
    "variable": "var(--bfIHqC)"
  },
  "sizes.breakpoint-desktop": {
    "value": "56.25rem",
    "variable": "var(--koQBGI)"
  },
  "spacing.0": {
    "value": "0px",
    "variable": "var(--fcTUxn)"
  },
  "spacing.1": {
    "value": "1px",
    "variable": "var(--dacYEG)"
  },
  "spacing.2": {
    "value": "2px",
    "variable": "var(--ebuyxV)"
  },
  "spacing.4": {
    "value": "4px",
    "variable": "var(--hIimNX)"
  },
  "spacing.8": {
    "value": "8px",
    "variable": "var(--flZesP)"
  },
  "spacing.12": {
    "value": "12px",
    "variable": "var(--uyqLg)"
  },
  "spacing.14": {
    "value": "14px",
    "variable": "var(--hXmVPi)"
  },
  "spacing.16": {
    "value": "16px",
    "variable": "var(--mYCWo)"
  },
  "spacing.20": {
    "value": "20px",
    "variable": "var(--jgejxp)"
  },
  "spacing.24": {
    "value": "24px",
    "variable": "var(--iYEvIx)"
  },
  "spacing.28": {
    "value": "28px",
    "variable": "var(--dzpWeZ)"
  },
  "spacing.32": {
    "value": "32px",
    "variable": "var(--fifqnK)"
  },
  "spacing.40": {
    "value": "40px",
    "variable": "var(--bxwoov)"
  },
  "spacing.48": {
    "value": "48px",
    "variable": "var(--hgdKvb)"
  },
  "spacing.56": {
    "value": "56px",
    "variable": "var(--iXfUeA)"
  },
  "spacing.64": {
    "value": "64px",
    "variable": "var(--gtqdrN)"
  },
  "spacing.72": {
    "value": "72px",
    "variable": "var(--hNtIEu)"
  },
  "spacing.80": {
    "value": "80px",
    "variable": "var(--kqIPsj)"
  },
  "spacing.88": {
    "value": "88px",
    "variable": "var(--erKiiP)"
  },
  "spacing.96": {
    "value": "96px",
    "variable": "var(--wdMRQ)"
  },
  "spacing.104": {
    "value": "104px",
    "variable": "var(--boAJxa)"
  },
  "spacing.112": {
    "value": "112px",
    "variable": "var(--hTGFal)"
  },
  "spacing.120": {
    "value": "120px",
    "variable": "var(--fnojBo)"
  },
  "spacing.128": {
    "value": "128px",
    "variable": "var(--eMNBM)"
  },
  "spacing.136": {
    "value": "136px",
    "variable": "var(--cSesfz)"
  },
  "spacing.144": {
    "value": "144px",
    "variable": "var(--bwaxlS)"
  },
  "spacing.152": {
    "value": "152px",
    "variable": "var(--hMgRlt)"
  },
  "spacing.160": {
    "value": "160px",
    "variable": "var(--ffOvMw)"
  },
  "spacing.176": {
    "value": "176px",
    "variable": "var(--cZEfUr)"
  },
  "spacing.192": {
    "value": "192px",
    "variable": "var(--cmSrHV)"
  },
  "spacing.208": {
    "value": "208px",
    "variable": "var(--iQsGnV)"
  },
  "spacing.224": {
    "value": "224px",
    "variable": "var(--bxwZFH)"
  },
  "spacing.240": {
    "value": "240px",
    "variable": "var(--cBYEZJ)"
  },
  "spacing.256": {
    "value": "256px",
    "variable": "var(--hScdCy)"
  },
  "spacing.288": {
    "value": "288px",
    "variable": "var(--dhLkhp)"
  },
  "spacing.320": {
    "value": "320px",
    "variable": "var(--kaVjdS)"
  },
  "spacing.352": {
    "value": "352px",
    "variable": "var(--iMsQUf)"
  },
  "spacing.384": {
    "value": "384px",
    "variable": "var(--fVIJEo)"
  },
  "spacing.400": {
    "value": "400px",
    "variable": "var(--gqmheD)"
  },
  "spacing.416": {
    "value": "416px",
    "variable": "var(--qtBDM)"
  },
  "spacing.432": {
    "value": "432px",
    "variable": "var(--cptfTi)"
  },
  "spacing.448": {
    "value": "448px",
    "variable": "var(--hfdWhL)"
  },
  "spacing.464": {
    "value": "464px",
    "variable": "var(--kLZPHB)"
  },
  "spacing.480": {
    "value": "480px",
    "variable": "var(--JxTMn)"
  },
  "spacing.512": {
    "value": "512px",
    "variable": "var(--kyUXqV)"
  },
  "spacing.544": {
    "value": "544px",
    "variable": "var(--eboPCC)"
  },
  "zIndex.banner": {
    "value": 10,
    "variable": "var(--dfMdbu)"
  },
  "zIndex.dialog": {
    "value": 100,
    "variable": "var(--cayCXq)"
  },
  "zIndex.popover": {
    "value": 200,
    "variable": "var(--beAiOT)"
  },
  "zIndex.toast": {
    "value": 300,
    "variable": "var(--BtcyX)"
  },
  "gradients.metrics": {
    "value": "linear-gradient(99deg, #352500 -2.64%, var(--lkwcEi) 33.37%)",
    "variable": "var(--krAGlo)"
  },
  "gradients.transparentToDark": {
    "value": "linear-gradient(99deg, var(--edNtiq) 0%, var(--lkwcEi) 100%)",
    "variable": "var(--hmIJRW)"
  },
  "gradients.modalBackground": {
    "value": "linear-gradient(218deg, var(--fqtMyj) 5.09%, var(--becVSn) 94.58%)",
    "variable": "var(--dCqfcG)"
  },
  "gradients.vaultCardBackground": {
    "value": "linear-gradient(214deg, var(--fqtMyj) 5.14%, var(--becVSn) 124.99%)",
    "variable": "var(--izsGrj)"
  },
  "gradients.tokenDetailBackground": {
    "value": "linear-gradient(110deg, #1F1F1F 7.91%, #292929 62.89%, #1F1F1F 93.56%)",
    "variable": "var(--gLYejf)"
  },
  "gradients.preDepositShareCardBackground": {
    "value": "linear-gradient(180deg, #101219 0%, #101219 48%, var(--cYiwaH) 48%, var(--cYiwaH) 100%)",
    "variable": "var(--hdCHQL)"
  },
  "gradients.rewardsBanner": {
    "value": "linear-gradient(141deg, var(--cObWdp) 2.64%, var(--lkwcEi) 33.37%)",
    "variable": "var(--izDQin)"
  },
  "gradients.rewardCardNonClaimable": {
    "value": "linear-gradient(225deg, var(--efYHCb) 0%, var(--lkwcEi) 100%)",
    "variable": "var(--lgUbrT)"
  },
  "breakpoints.xs": {
    "value": "24.375rem",
    "variable": "var(--flUDPF)"
  },
  "breakpoints.sm": {
    "value": "37.5rem",
    "variable": "var(--ikokJA)"
  },
  "breakpoints.md": {
    "value": "56.25rem",
    "variable": "var(--kSvAmr)"
  },
  "breakpoints.lg": {
    "value": "75rem",
    "variable": "var(--uwdhN)"
  },
  "breakpoints.xl": {
    "value": "96rem",
    "variable": "var(--eyfDzy)"
  },
  "breakpoints.xxl": {
    "value": "120rem",
    "variable": "var(--dymagS)"
  },
  "breakpoints.desktop": {
    "value": "56.25rem",
    "variable": "var(--dlPwCk)"
  },
  "colors.text.primary": {
    "value": "var(--gcCerW)",
    "variable": "var(--iagzVE)"
  },
  "colors.text.secondary": {
    "value": "var(--hEiqGh)",
    "variable": "var(--YyYdq)"
  },
  "colors.text.tertiary": {
    "value": "var(--jKPbeg)",
    "variable": "var(--kFAOBM)"
  },
  "colors.text.contrast": {
    "value": "var(--qLIrn)",
    "variable": "var(--dmlENi)"
  },
  "colors.text.link": {
    "value": "#EFEFEF",
    "variable": "var(--epnrWg)"
  },
  "colors.text.link.hover": {
    "value": "var(--gcCerW)",
    "variable": "var(--bmhdtr)"
  },
  "colors.text.disabled": {
    "value": "var(--fTTGyH)",
    "variable": "var(--gNPUFA)"
  },
  "colors.text.positive": {
    "value": "var(--iDDIAz)",
    "variable": "var(--kbFtRX)"
  },
  "colors.text.positiveBright": {
    "value": "var(--xlzhi)",
    "variable": "var(--jDCQTB)"
  },
  "colors.text.negative": {
    "value": "var(--bLdQLg)",
    "variable": "var(--cUiFpz)"
  },
  "colors.text.highlight": {
    "value": "var(--cojwIP)",
    "variable": "var(--iiuMtk)"
  },
  "colors.text.warning": {
    "value": "var(--fwcFBW)",
    "variable": "var(--ijzQoe)"
  },
  "colors.background.canvas": {
    "value": "var(--lkwcEi)",
    "variable": "var(--becVSn)"
  },
  "colors.background.primary": {
    "value": "var(--efYHCb)",
    "variable": "var(--fqtMyj)"
  },
  "colors.background.secondary": {
    "value": "var(--RfAvF)",
    "variable": "var(--eUYwxZ)"
  },
  "colors.background.tertiary": {
    "value": "var(--ELegn)",
    "variable": "var(--gwobmr)"
  },
  "colors.background.disabled": {
    "value": "var(--ELegn)",
    "variable": "var(--bvWhaf)"
  },
  "colors.background.brandSubtle": {
    "value": "color-mix(in srgb, var(--cYiwaH) 5%, transparent)",
    "variable": "var(--ijOEBl)"
  },
  "colors.background.positive": {
    "value": "var(--wGfza)",
    "variable": "var(--iHmITQ)"
  },
  "colors.background.positiveLight": {
    "value": "var(--iDDIAz)",
    "variable": "var(--jVwwSG)"
  },
  "colors.background.positiveActive": {
    "value": "#9ee77c",
    "variable": "var(--jHhtno)"
  },
  "colors.background.negative": {
    "value": "var(--iYfRb)",
    "variable": "var(--bSiVbc)"
  },
  "colors.background.negativeLight": {
    "value": "var(--bLdQLg)",
    "variable": "var(--ebfsgG)"
  },
  "colors.background.negativeActive": {
    "value": "#f4754b",
    "variable": "var(--bLyik)"
  },
  "colors.tradingModeLayout.positive": {
    "value": "var(--wGfza)",
    "variable": "var(--cPnlRo)"
  },
  "colors.tradingModeLayout.negative": {
    "value": "var(--fMUQaR)",
    "variable": "var(--eppltM)"
  },
  "colors.tradingModeLayout.neutral": {
    "value": "var(--hJiziu)",
    "variable": "var(--dgMtVO)"
  },
  "colors.tradingModeLayout.primary": {
    "value": "var(--cTpZLL)",
    "variable": "var(--bNZBIL)"
  },
  "colors.border.primary": {
    "value": "var(--RfAvF)",
    "variable": "var(--iACgot)"
  },
  "colors.border.secondary": {
    "value": "var(--hJiziu)",
    "variable": "var(--fkecPj)"
  },
  "colors.border.tertiary": {
    "value": "var(--ELegn)",
    "variable": "var(--kiJceJ)"
  },
  "colors.border.positive": {
    "value": "var(--hypAVx)",
    "variable": "var(--gyITlG)"
  },
  "colors.border.negative": {
    "value": "var(--fMUQaR)",
    "variable": "var(--kcBUHq)"
  },
  "colors.border.active": {
    "value": "var(--loWpng)",
    "variable": "var(--gfdzIt)"
  },
  "colors.border.hover": {
    "value": "var(--gnsFGO)",
    "variable": "var(--bBGrTT)"
  },
  "colors.border.highlight": {
    "value": "var(--hbNTWc)",
    "variable": "var(--kNPRLd)"
  },
  "colors.border.focus": {
    "value": "#0D9BDB",
    "variable": "var(--cblusd)"
  },
  "colors.border.positiveActive": {
    "value": "var(--iDDIAz)",
    "variable": "var(--dMDySW)"
  },
  "colors.border.negativeActive": {
    "value": "var(--bLdQLg)",
    "variable": "var(--eRTNeO)"
  },
  "colors.icon.primary": {
    "value": "var(--gcCerW)",
    "variable": "var(--liPjPi)"
  },
  "colors.icon.secondary": {
    "value": "var(--hEiqGh)",
    "variable": "var(--frSdYc)"
  },
  "colors.icon.tertiary": {
    "value": "var(--jKPbeg)",
    "variable": "var(--iBxDfG)"
  },
  "colors.icon.highlight": {
    "value": "var(--loWpng)",
    "variable": "var(--iqZeWq)"
  },
  "colors.icon.positive": {
    "value": "var(--iDDIAz)",
    "variable": "var(--dLpTMd)"
  },
  "colors.icon.negative": {
    "value": "var(--fKgVwH)",
    "variable": "var(--gnGgGJ)"
  },
  "colors.icon.warning": {
    "value": "var(--loWpng)",
    "variable": "var(--csBOUs)"
  },
  "colors.dataViz.positive": {
    "value": "var(--khfuXU)",
    "variable": "var(--qmPKv)"
  },
  "colors.dataViz.negative": {
    "value": "var(--fKgVwH)",
    "variable": "var(--erxreD)"
  },
  "colors.spinner.primary.arc": {
    "value": "var(--hEiqGh)",
    "variable": "var(--cvvaLd)"
  },
  "colors.spinner.primary.track": {
    "value": "color-mix(in srgb, var(--hEiqGh) 40%, transparent)",
    "variable": "var(--hKBZpC)"
  },
  "colors.spinner.secondary.arc": {
    "value": "var(--jKPbeg)",
    "variable": "var(--VZEub)"
  },
  "colors.spinner.secondary.track": {
    "value": "color-mix(in srgb, var(--jKPbeg) 20%, transparent)",
    "variable": "var(--ktHVSo)"
  },
  "colors.spinner.destructive.arc": {
    "value": "var(--bLdQLg)",
    "variable": "var(--gMYcjZ)"
  },
  "colors.spinner.destructive.track": {
    "value": "color-mix(in srgb, var(--bLdQLg) 20%, transparent)",
    "variable": "var(--goJCpS)"
  },
  "colors.spinner.onPrimary.arc": {
    "value": "var(--qLIrn)",
    "variable": "var(--fSwRPc)"
  },
  "colors.spinner.onPrimary.track": {
    "value": "color-mix(in srgb, var(--qLIrn) 20%, transparent)",
    "variable": "var(--evPmqz)"
  },
  "colors.skeleton": {
    "value": "var(--eUYwxZ)",
    "variable": "var(--fEwOXZ)"
  },
  "colors.skeleton.shimmer1": {
    "value": "var(--edNtiq)",
    "variable": "var(--dtCASU)"
  },
  "colors.skeleton.shimmer2": {
    "value": "color-mix(in srgb, var(--efYHCb) 20%, transparent)",
    "variable": "var(--jyVtZr)"
  },
  "colors.skeleton.shimmer3": {
    "value": "color-mix(in srgb, var(--efYHCb) 50%, transparent)",
    "variable": "var(--eWCTYe)"
  },
  "colors.card.background": {
    "value": "var(--fqtMyj)",
    "variable": "var(--eoJqvn)"
  },
  "colors.card.border": {
    "value": "var(--iACgot)",
    "variable": "var(--eTMwuJ)"
  },
  "colors.button.primary.background": {
    "value": "var(--loWpng)",
    "variable": "var(--dyZNJg)"
  },
  "colors.button.primary.text": {
    "value": "var(--qLIrn)",
    "variable": "var(--bEMDjD)"
  },
  "colors.button.primary.hover.background": {
    "value": "var(--hUTJsd)",
    "variable": "var(--iMZZnL)"
  },
  "colors.button.primary.hover.text": {
    "value": "var(--qLIrn)",
    "variable": "var(--hDXDUc)"
  },
  "colors.button.primary.pressed.background": {
    "value": "var(--cTpZLL)",
    "variable": "var(--dyQSIr)"
  },
  "colors.button.primary.pressed.text": {
    "value": "var(--qLIrn)",
    "variable": "var(--gShHLw)"
  },
  "colors.button.primary.disabled.background": {
    "value": "var(--bvWhaf)",
    "variable": "var(--eTmLBd)"
  },
  "colors.button.primary.disabled.text": {
    "value": "var(--gNPUFA)",
    "variable": "var(--kJxJdW)"
  },
  "colors.button.secondary.background": {
    "value": "var(--gwobmr)",
    "variable": "var(--gficIC)"
  },
  "colors.button.secondary.text": {
    "value": "var(--hEiqGh)",
    "variable": "var(--jHmqjJ)"
  },
  "colors.button.secondary.hover.background": {
    "value": "var(--hJiziu)",
    "variable": "var(--dsVAeF)"
  },
  "colors.button.secondary.hover.text": {
    "value": "var(--hEiqGh)",
    "variable": "var(--cRBtNa)"
  },
  "colors.button.secondary.pressed.background": {
    "value": "var(--RfAvF)",
    "variable": "var(--fEQpJ)"
  },
  "colors.button.secondary.pressed.text": {
    "value": "var(--hEiqGh)",
    "variable": "var(--bRJwTy)"
  },
  "colors.button.secondary.disabled.background": {
    "value": "var(--bvWhaf)",
    "variable": "var(--jItTZn)"
  },
  "colors.button.secondary.disabled.text": {
    "value": "var(--gNPUFA)",
    "variable": "var(--eEEnQY)"
  },
  "colors.button.brand.background": {
    "value": "var(--cYiwaH)",
    "variable": "var(--jOroNz)"
  },
  "colors.button.brand.text": {
    "value": "var(--qLIrn)",
    "variable": "var(--imtMRA)"
  },
  "colors.button.brand.hover.background": {
    "value": "var(--jSeelK)",
    "variable": "var(--dntkcg)"
  },
  "colors.button.brand.hover.text": {
    "value": "var(--qLIrn)",
    "variable": "var(--bmBafz)"
  },
  "colors.button.brand.pressed.background": {
    "value": "var(--juwqZg)",
    "variable": "var(--cusaAg)"
  },
  "colors.button.brand.pressed.text": {
    "value": "var(--qLIrn)",
    "variable": "var(--fiVTMv)"
  },
  "colors.button.brand.disabled.background": {
    "value": "var(--bvWhaf)",
    "variable": "var(--hiGbyi)"
  },
  "colors.button.brand.disabled.text": {
    "value": "var(--gNPUFA)",
    "variable": "var(--jMGcMZ)"
  },
  "colors.button.destructive.background": {
    "value": "var(--bSiVbc)",
    "variable": "var(--iqoBRg)"
  },
  "colors.button.destructive.text": {
    "value": "var(--cUiFpz)",
    "variable": "var(--libwNv)"
  },
  "colors.button.destructive.hover.background": {
    "value": "var(--hwCQam)",
    "variable": "var(--hVZowb)"
  },
  "colors.button.destructive.hover.text": {
    "value": "var(--cUiFpz)",
    "variable": "var(--dVSxBE)"
  },
  "colors.button.destructive.pressed.background": {
    "value": "var(--bSiVbc)",
    "variable": "var(--jcwcUH)"
  },
  "colors.button.destructive.pressed.text": {
    "value": "var(--cUiFpz)",
    "variable": "var(--cGJtSQ)"
  },
  "colors.button.destructive.disabled.background": {
    "value": "var(--bvWhaf)",
    "variable": "var(--fasxgh)"
  },
  "colors.button.destructive.disabled.text": {
    "value": "var(--gNPUFA)",
    "variable": "var(--hvAyAu)"
  },
  "colors.button.text.text": {
    "value": "var(--YyYdq)",
    "variable": "var(--ddPuvm)"
  },
  "colors.button.text.hover.text": {
    "value": "var(--iagzVE)",
    "variable": "var(--eFDiYZ)"
  },
  "colors.button.text.pressed.text": {
    "value": "var(--kFAOBM)",
    "variable": "var(--crhTtV)"
  },
  "colors.button.text.disabled.text": {
    "value": "var(--gNPUFA)",
    "variable": "var(--dWWHtH)"
  },
  "colors.button.buy.text": {
    "value": "var(--dmlENi)",
    "variable": "var(--gSlCoR)"
  },
  "colors.button.buy.background": {
    "value": "var(--jVwwSG)",
    "variable": "var(--dmuwnm)"
  },
  "colors.button.buy.hover.background": {
    "value": "var(--jHhtno)",
    "variable": "var(--htqLTh)"
  },
  "colors.button.buy.pressed.background": {
    "value": "var(--jHhtno)",
    "variable": "var(--kfhCml)"
  },
  "colors.button.buy.disabled.background": {
    "value": "var(--khfuXU)",
    "variable": "var(--dZVQnj)"
  },
  "colors.button.sell.text": {
    "value": "var(--dmlENi)",
    "variable": "var(--kxAnxF)"
  },
  "colors.button.sell.background": {
    "value": "var(--ebfsgG)",
    "variable": "var(--ivivQq)"
  },
  "colors.button.sell.hover.background": {
    "value": "var(--bLyik)",
    "variable": "var(--fITlQR)"
  },
  "colors.button.sell.pressed.background": {
    "value": "var(--bLyik)",
    "variable": "var(--fpKIeZ)"
  },
  "colors.button.sell.disabled.background": {
    "value": "var(--fMUQaR)",
    "variable": "var(--bmOEFP)"
  },
  "colors.alert.background": {
    "value": "var(--eUYwxZ)",
    "variable": "var(--eBAGXx)"
  },
  "colors.alert.text": {
    "value": "var(--iagzVE)",
    "variable": "var(--llsHPu)"
  },
  "colors.dialog.backdrop": {
    "value": "color-mix(in srgb, var(--qLIrn) 80%, transparent)",
    "variable": "var(--jwCzqX)"
  },
  "colors.toast.background": {
    "value": "var(--gwobmr)",
    "variable": "var(--hPBSNm)"
  },
  "colors.toast.text.title": {
    "value": "var(--iagzVE)",
    "variable": "var(--lngiHs)"
  },
  "colors.toast.text.description": {
    "value": "var(--YyYdq)",
    "variable": "var(--kSecHm)"
  },
  "colors.toast.border": {
    "value": "var(--kiJceJ)",
    "variable": "var(--crOfPw)"
  },
  "colors.checkbox.background": {
    "value": "var(--eUYwxZ)",
    "variable": "var(--dxuZMo)"
  },
  "colors.checkbox.background.checked": {
    "value": "var(--gwobmr)",
    "variable": "var(--gxhczO)"
  },
  "colors.checkbox.background.hover": {
    "value": "var(--ELegn)",
    "variable": "var(--ginDqT)"
  },
  "colors.checkbox.background.disabled": {
    "value": "var(--bvWhaf)",
    "variable": "var(--dvvTAt)"
  },
  "colors.checkbox.border": {
    "value": "var(--fkecPj)",
    "variable": "var(--eErDa)"
  },
  "colors.checkbox.border.hover": {
    "value": "var(--kiJceJ)",
    "variable": "var(--gzLbsh)"
  },
  "colors.checkbox.check": {
    "value": "var(--hEiqGh)",
    "variable": "var(--fDwwfA)"
  },
  "colors.checkbox.check.disabled": {
    "value": "var(--gNPUFA)",
    "variable": "var(--kAGWoR)"
  },
  "colors.slider.track": {
    "value": "var(--gwobmr)",
    "variable": "var(--WxZOX)"
  },
  "colors.slider.track.danger": {
    "value": "color-mix(in srgb, var(--fKgVwH) 25%, transparent)",
    "variable": "var(--RcnKx)"
  },
  "colors.slider.range": {
    "value": "var(--loWpng)",
    "variable": "var(--hzxpab)"
  },
  "colors.slider.range.danger": {
    "value": "var(--fKgVwH)",
    "variable": "var(--cAvTUF)"
  },
  "colors.tooltip.background": {
    "value": "var(--becVSn)",
    "variable": "var(--fWNtgi)"
  },
  "colors.tooltip.text": {
    "value": "var(--loWpng)",
    "variable": "var(--jLxIlN)"
  },
  "colors.orderbook.askDepthBar.background": {
    "value": "var(--bSiVbc)",
    "variable": "var(--fcGcik)"
  },
  "colors.orderbook.askDepthBar.text": {
    "value": "var(--cUiFpz)",
    "variable": "var(--dESCdD)"
  },
  "colors.orderbook.askDepthBar.flash": {
    "value": "color-mix(in srgb, var(--bSiVbc) 60%, transparent)",
    "variable": "var(--Iiyly)"
  },
  "colors.orderbook.bidDepthBar.background": {
    "value": "var(--iHmITQ)",
    "variable": "var(--chGCvy)"
  },
  "colors.orderbook.bidDepthBar.text": {
    "value": "var(--kbFtRX)",
    "variable": "var(--ckZxFZ)"
  },
  "colors.orderbook.bidDepthBar.flash": {
    "value": "color-mix(in srgb, var(--iHmITQ) 60%, transparent)",
    "variable": "var(--ejBZcQ)"
  },
  "colors.orderbook.userOrderIndicator": {
    "value": "var(--loWpng)",
    "variable": "var(--bLphZg)"
  },
  "colors.radio.background": {
    "value": "var(--eUYwxZ)",
    "variable": "var(--hSeDAC)"
  },
  "colors.radio.background.checked": {
    "value": "var(--gwobmr)",
    "variable": "var(--hpgmGE)"
  },
  "colors.banner.text": {
    "value": "var(--qLIrn)",
    "variable": "var(--iOOLqY)"
  },
  "colors.banner.warning": {
    "value": "var(--loWpng)",
    "variable": "var(--ClTnH)"
  },
  "colors.banner.critical": {
    "value": "var(--erxreD)",
    "variable": "var(--eZexaK)"
  },
  "colors.banner.positive": {
    "value": "var(--wGfza)",
    "variable": "var(--kneqzG)"
  },
  "colors.banner.positiveText": {
    "value": "var(--RiClf)",
    "variable": "var(--cvjVYr)"
  },
  "colors.tag.background.primary": {
    "value": "var(--eUYwxZ)",
    "variable": "var(--kIHSSg)"
  },
  "colors.tag.background.secondary": {
    "value": "var(--eUYwxZ)",
    "variable": "var(--bWrVYO)"
  },
  "colors.tag.background.neutral": {
    "value": "var(--gwobmr)",
    "variable": "var(--gnsRep)"
  },
  "colors.tag.background.gold": {
    "value": "var(--dVBFRQ)",
    "variable": "var(--bFhxsI)"
  },
  "colors.tag.background.positive": {
    "value": "var(--iHmITQ)",
    "variable": "var(--cJGONL)"
  },
  "colors.tag.background.negative": {
    "value": "var(--bSiVbc)",
    "variable": "var(--cIXdvL)"
  },
  "colors.tag.text.primary": {
    "value": "var(--YyYdq)",
    "variable": "var(--kkpJAn)"
  },
  "colors.tag.text.secondary": {
    "value": "var(--kFAOBM)",
    "variable": "var(--gAroqt)"
  },
  "colors.tag.text.neutral": {
    "value": "var(--kFAOBM)",
    "variable": "var(--jvmLqS)"
  },
  "colors.tag.text.gold": {
    "value": "var(--loWpng)",
    "variable": "var(--gPJOyP)"
  },
  "colors.tag.text.positive": {
    "value": "var(--kbFtRX)",
    "variable": "var(--blotck)"
  },
  "colors.tag.text.negative": {
    "value": "var(--cUiFpz)",
    "variable": "var(--fdGNPM)"
  },
  "radii.primary": {
    "value": "var(--ksYUhH)",
    "variable": "var(--jwwDBh)"
  },
  "radii.secondary": {
    "value": "var(--gDEwJY)",
    "variable": "var(--kSrcSv)"
  },
  "spacing.-0": {
    "value": "calc(var(--fcTUxn) * -1)",
    "variable": "var(--fcTUxn)"
  },
  "spacing.-1": {
    "value": "calc(var(--dacYEG) * -1)",
    "variable": "var(--dacYEG)"
  },
  "spacing.-2": {
    "value": "calc(var(--ebuyxV) * -1)",
    "variable": "var(--ebuyxV)"
  },
  "spacing.-4": {
    "value": "calc(var(--hIimNX) * -1)",
    "variable": "var(--hIimNX)"
  },
  "spacing.-8": {
    "value": "calc(var(--flZesP) * -1)",
    "variable": "var(--flZesP)"
  },
  "spacing.-12": {
    "value": "calc(var(--uyqLg) * -1)",
    "variable": "var(--uyqLg)"
  },
  "spacing.-14": {
    "value": "calc(var(--hXmVPi) * -1)",
    "variable": "var(--hXmVPi)"
  },
  "spacing.-16": {
    "value": "calc(var(--mYCWo) * -1)",
    "variable": "var(--mYCWo)"
  },
  "spacing.-20": {
    "value": "calc(var(--jgejxp) * -1)",
    "variable": "var(--jgejxp)"
  },
  "spacing.-24": {
    "value": "calc(var(--iYEvIx) * -1)",
    "variable": "var(--iYEvIx)"
  },
  "spacing.-28": {
    "value": "calc(var(--dzpWeZ) * -1)",
    "variable": "var(--dzpWeZ)"
  },
  "spacing.-32": {
    "value": "calc(var(--fifqnK) * -1)",
    "variable": "var(--fifqnK)"
  },
  "spacing.-40": {
    "value": "calc(var(--bxwoov) * -1)",
    "variable": "var(--bxwoov)"
  },
  "spacing.-48": {
    "value": "calc(var(--hgdKvb) * -1)",
    "variable": "var(--hgdKvb)"
  },
  "spacing.-56": {
    "value": "calc(var(--iXfUeA) * -1)",
    "variable": "var(--iXfUeA)"
  },
  "spacing.-64": {
    "value": "calc(var(--gtqdrN) * -1)",
    "variable": "var(--gtqdrN)"
  },
  "spacing.-72": {
    "value": "calc(var(--hNtIEu) * -1)",
    "variable": "var(--hNtIEu)"
  },
  "spacing.-80": {
    "value": "calc(var(--kqIPsj) * -1)",
    "variable": "var(--kqIPsj)"
  },
  "spacing.-88": {
    "value": "calc(var(--erKiiP) * -1)",
    "variable": "var(--erKiiP)"
  },
  "spacing.-96": {
    "value": "calc(var(--wdMRQ) * -1)",
    "variable": "var(--wdMRQ)"
  },
  "spacing.-104": {
    "value": "calc(var(--boAJxa) * -1)",
    "variable": "var(--boAJxa)"
  },
  "spacing.-112": {
    "value": "calc(var(--hTGFal) * -1)",
    "variable": "var(--hTGFal)"
  },
  "spacing.-120": {
    "value": "calc(var(--fnojBo) * -1)",
    "variable": "var(--fnojBo)"
  },
  "spacing.-128": {
    "value": "calc(var(--eMNBM) * -1)",
    "variable": "var(--eMNBM)"
  },
  "spacing.-136": {
    "value": "calc(var(--cSesfz) * -1)",
    "variable": "var(--cSesfz)"
  },
  "spacing.-144": {
    "value": "calc(var(--bwaxlS) * -1)",
    "variable": "var(--bwaxlS)"
  },
  "spacing.-152": {
    "value": "calc(var(--hMgRlt) * -1)",
    "variable": "var(--hMgRlt)"
  },
  "spacing.-160": {
    "value": "calc(var(--ffOvMw) * -1)",
    "variable": "var(--ffOvMw)"
  },
  "spacing.-176": {
    "value": "calc(var(--cZEfUr) * -1)",
    "variable": "var(--cZEfUr)"
  },
  "spacing.-192": {
    "value": "calc(var(--cmSrHV) * -1)",
    "variable": "var(--cmSrHV)"
  },
  "spacing.-208": {
    "value": "calc(var(--iQsGnV) * -1)",
    "variable": "var(--iQsGnV)"
  },
  "spacing.-224": {
    "value": "calc(var(--bxwZFH) * -1)",
    "variable": "var(--bxwZFH)"
  },
  "spacing.-240": {
    "value": "calc(var(--cBYEZJ) * -1)",
    "variable": "var(--cBYEZJ)"
  },
  "spacing.-256": {
    "value": "calc(var(--hScdCy) * -1)",
    "variable": "var(--hScdCy)"
  },
  "spacing.-288": {
    "value": "calc(var(--dhLkhp) * -1)",
    "variable": "var(--dhLkhp)"
  },
  "spacing.-320": {
    "value": "calc(var(--kaVjdS) * -1)",
    "variable": "var(--kaVjdS)"
  },
  "spacing.-352": {
    "value": "calc(var(--iMsQUf) * -1)",
    "variable": "var(--iMsQUf)"
  },
  "spacing.-384": {
    "value": "calc(var(--fVIJEo) * -1)",
    "variable": "var(--fVIJEo)"
  },
  "spacing.-400": {
    "value": "calc(var(--gqmheD) * -1)",
    "variable": "var(--gqmheD)"
  },
  "spacing.-416": {
    "value": "calc(var(--qtBDM) * -1)",
    "variable": "var(--qtBDM)"
  },
  "spacing.-432": {
    "value": "calc(var(--cptfTi) * -1)",
    "variable": "var(--cptfTi)"
  },
  "spacing.-448": {
    "value": "calc(var(--hfdWhL) * -1)",
    "variable": "var(--hfdWhL)"
  },
  "spacing.-464": {
    "value": "calc(var(--kLZPHB) * -1)",
    "variable": "var(--kLZPHB)"
  },
  "spacing.-480": {
    "value": "calc(var(--JxTMn) * -1)",
    "variable": "var(--JxTMn)"
  },
  "spacing.-512": {
    "value": "calc(var(--kyUXqV) * -1)",
    "variable": "var(--kyUXqV)"
  },
  "spacing.-544": {
    "value": "calc(var(--eboPCC) * -1)",
    "variable": "var(--eboPCC)"
  },
  "colors.colorPalette": {
    "value": "var(--idUrcU)",
    "variable": "var(--idUrcU)"
  },
  "colors.colorPalette.100": {
    "value": "var(--iSScQY)",
    "variable": "var(--iSScQY)"
  },
  "colors.colorPalette.200": {
    "value": "var(--bdPmBD)",
    "variable": "var(--bdPmBD)"
  },
  "colors.colorPalette.300": {
    "value": "var(--EuecW)",
    "variable": "var(--EuecW)"
  },
  "colors.colorPalette.400": {
    "value": "var(--dIdJaV)",
    "variable": "var(--dIdJaV)"
  },
  "colors.colorPalette.500": {
    "value": "var(--iOGEjQ)",
    "variable": "var(--iOGEjQ)"
  },
  "colors.colorPalette.600": {
    "value": "var(--ZDNUv)",
    "variable": "var(--ZDNUv)"
  },
  "colors.colorPalette.700": {
    "value": "var(--AiFvO)",
    "variable": "var(--AiFvO)"
  },
  "colors.colorPalette.150": {
    "value": "var(--lgCAFt)",
    "variable": "var(--lgCAFt)"
  },
  "colors.colorPalette.550": {
    "value": "var(--lkNZmB)",
    "variable": "var(--lkNZmB)"
  },
  "colors.colorPalette.800": {
    "value": "var(--iCIPjV)",
    "variable": "var(--iCIPjV)"
  },
  "colors.colorPalette.900": {
    "value": "var(--ctQaTU)",
    "variable": "var(--ctQaTU)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--gbCbhR)",
    "variable": "var(--gbCbhR)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--dDofdL)",
    "variable": "var(--dDofdL)"
  },
  "colors.colorPalette.tertiary": {
    "value": "var(--fMuFOV)",
    "variable": "var(--fMuFOV)"
  },
  "colors.colorPalette.contrast": {
    "value": "var(--ksbVpn)",
    "variable": "var(--ksbVpn)"
  },
  "colors.colorPalette.link": {
    "value": "var(--cYQGgt)",
    "variable": "var(--cYQGgt)"
  },
  "colors.colorPalette.link.hover": {
    "value": "var(--hxwDAO)",
    "variable": "var(--hxwDAO)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--hjJRhX)",
    "variable": "var(--hjJRhX)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--gTYnIJ)",
    "variable": "var(--gTYnIJ)"
  },
  "colors.colorPalette.positive": {
    "value": "var(--eedBlu)",
    "variable": "var(--eedBlu)"
  },
  "colors.colorPalette.positiveBright": {
    "value": "var(--kGCWWc)",
    "variable": "var(--kGCWWc)"
  },
  "colors.colorPalette.negative": {
    "value": "var(--cdjrCi)",
    "variable": "var(--cdjrCi)"
  },
  "colors.colorPalette.highlight": {
    "value": "var(--eBkqEd)",
    "variable": "var(--eBkqEd)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--hmRtaX)",
    "variable": "var(--hmRtaX)"
  },
  "colors.colorPalette.canvas": {
    "value": "var(--jsIbit)",
    "variable": "var(--jsIbit)"
  },
  "colors.colorPalette.brandSubtle": {
    "value": "var(--lhakJn)",
    "variable": "var(--lhakJn)"
  },
  "colors.colorPalette.positiveLight": {
    "value": "var(--fqZLdY)",
    "variable": "var(--fqZLdY)"
  },
  "colors.colorPalette.positiveActive": {
    "value": "var(--eDEkRW)",
    "variable": "var(--eDEkRW)"
  },
  "colors.colorPalette.negativeLight": {
    "value": "var(--bChlaM)",
    "variable": "var(--bChlaM)"
  },
  "colors.colorPalette.negativeActive": {
    "value": "var(--bRHpVi)",
    "variable": "var(--bRHpVi)"
  },
  "colors.colorPalette.neutral": {
    "value": "var(--hXmFow)",
    "variable": "var(--hXmFow)"
  },
  "colors.colorPalette.active": {
    "value": "var(--iaREDJ)",
    "variable": "var(--iaREDJ)"
  },
  "colors.colorPalette.focus": {
    "value": "var(--iAisux)",
    "variable": "var(--iAisux)"
  },
  "colors.colorPalette.primary.arc": {
    "value": "var(--ggGsho)",
    "variable": "var(--ggGsho)"
  },
  "colors.colorPalette.arc": {
    "value": "var(--eJRNAJ)",
    "variable": "var(--eJRNAJ)"
  },
  "colors.colorPalette.primary.track": {
    "value": "var(--hDEECv)",
    "variable": "var(--hDEECv)"
  },
  "colors.colorPalette.track": {
    "value": "var(--lmBpSe)",
    "variable": "var(--lmBpSe)"
  },
  "colors.colorPalette.secondary.arc": {
    "value": "var(--dECRtG)",
    "variable": "var(--dECRtG)"
  },
  "colors.colorPalette.secondary.track": {
    "value": "var(--fJlzzV)",
    "variable": "var(--fJlzzV)"
  },
  "colors.colorPalette.destructive.arc": {
    "value": "var(--dqkvng)",
    "variable": "var(--dqkvng)"
  },
  "colors.colorPalette.destructive.track": {
    "value": "var(--bJEoyf)",
    "variable": "var(--bJEoyf)"
  },
  "colors.colorPalette.onPrimary.arc": {
    "value": "var(--hKbTId)",
    "variable": "var(--hKbTId)"
  },
  "colors.colorPalette.onPrimary.track": {
    "value": "var(--fqBXjG)",
    "variable": "var(--fqBXjG)"
  },
  "colors.colorPalette.shimmer1": {
    "value": "var(--lnrFAh)",
    "variable": "var(--lnrFAh)"
  },
  "colors.colorPalette.shimmer2": {
    "value": "var(--bfKAtG)",
    "variable": "var(--bfKAtG)"
  },
  "colors.colorPalette.shimmer3": {
    "value": "var(--cmluMf)",
    "variable": "var(--cmluMf)"
  },
  "colors.colorPalette.background": {
    "value": "var(--ccMjBz)",
    "variable": "var(--ccMjBz)"
  },
  "colors.colorPalette.border": {
    "value": "var(--jrPpPJ)",
    "variable": "var(--jrPpPJ)"
  },
  "colors.colorPalette.primary.background": {
    "value": "var(--dwuuKu)",
    "variable": "var(--dwuuKu)"
  },
  "colors.colorPalette.primary.text": {
    "value": "var(--fPPajJ)",
    "variable": "var(--fPPajJ)"
  },
  "colors.colorPalette.text": {
    "value": "var(--yVRWg)",
    "variable": "var(--yVRWg)"
  },
  "colors.colorPalette.primary.hover.background": {
    "value": "var(--gyzgLR)",
    "variable": "var(--gyzgLR)"
  },
  "colors.colorPalette.hover.background": {
    "value": "var(--giHJgM)",
    "variable": "var(--giHJgM)"
  },
  "colors.colorPalette.primary.hover.text": {
    "value": "var(--jkXptq)",
    "variable": "var(--jkXptq)"
  },
  "colors.colorPalette.hover.text": {
    "value": "var(--dVNsRb)",
    "variable": "var(--dVNsRb)"
  },
  "colors.colorPalette.primary.pressed.background": {
    "value": "var(--kozcyp)",
    "variable": "var(--kozcyp)"
  },
  "colors.colorPalette.pressed.background": {
    "value": "var(--fpGzEM)",
    "variable": "var(--fpGzEM)"
  },
  "colors.colorPalette.primary.pressed.text": {
    "value": "var(--djKdIe)",
    "variable": "var(--djKdIe)"
  },
  "colors.colorPalette.pressed.text": {
    "value": "var(--hSimxX)",
    "variable": "var(--hSimxX)"
  },
  "colors.colorPalette.primary.disabled.background": {
    "value": "var(--gDnahn)",
    "variable": "var(--gDnahn)"
  },
  "colors.colorPalette.disabled.background": {
    "value": "var(--cLKYcW)",
    "variable": "var(--cLKYcW)"
  },
  "colors.colorPalette.primary.disabled.text": {
    "value": "var(--deTacI)",
    "variable": "var(--deTacI)"
  },
  "colors.colorPalette.disabled.text": {
    "value": "var(--bPalmR)",
    "variable": "var(--bPalmR)"
  },
  "colors.colorPalette.secondary.background": {
    "value": "var(--bfcFes)",
    "variable": "var(--bfcFes)"
  },
  "colors.colorPalette.secondary.text": {
    "value": "var(--FGIMP)",
    "variable": "var(--FGIMP)"
  },
  "colors.colorPalette.secondary.hover.background": {
    "value": "var(--eePvij)",
    "variable": "var(--eePvij)"
  },
  "colors.colorPalette.secondary.hover.text": {
    "value": "var(--fsiNYs)",
    "variable": "var(--fsiNYs)"
  },
  "colors.colorPalette.secondary.pressed.background": {
    "value": "var(--eRcOMb)",
    "variable": "var(--eRcOMb)"
  },
  "colors.colorPalette.secondary.pressed.text": {
    "value": "var(--irxQMs)",
    "variable": "var(--irxQMs)"
  },
  "colors.colorPalette.secondary.disabled.background": {
    "value": "var(--ifCWBt)",
    "variable": "var(--ifCWBt)"
  },
  "colors.colorPalette.secondary.disabled.text": {
    "value": "var(--kOENke)",
    "variable": "var(--kOENke)"
  },
  "colors.colorPalette.brand.background": {
    "value": "var(--itXeiZ)",
    "variable": "var(--itXeiZ)"
  },
  "colors.colorPalette.brand.text": {
    "value": "var(--cRtjsi)",
    "variable": "var(--cRtjsi)"
  },
  "colors.colorPalette.brand.hover.background": {
    "value": "var(--dynqPK)",
    "variable": "var(--dynqPK)"
  },
  "colors.colorPalette.brand.hover.text": {
    "value": "var(--cwjuGR)",
    "variable": "var(--cwjuGR)"
  },
  "colors.colorPalette.brand.pressed.background": {
    "value": "var(--eEKfoq)",
    "variable": "var(--eEKfoq)"
  },
  "colors.colorPalette.brand.pressed.text": {
    "value": "var(--bhaqYd)",
    "variable": "var(--bhaqYd)"
  },
  "colors.colorPalette.brand.disabled.background": {
    "value": "var(--gAvWnQ)",
    "variable": "var(--gAvWnQ)"
  },
  "colors.colorPalette.brand.disabled.text": {
    "value": "var(--jnGmVX)",
    "variable": "var(--jnGmVX)"
  },
  "colors.colorPalette.destructive.background": {
    "value": "var(--kTLNWu)",
    "variable": "var(--kTLNWu)"
  },
  "colors.colorPalette.destructive.text": {
    "value": "var(--dfXVux)",
    "variable": "var(--dfXVux)"
  },
  "colors.colorPalette.destructive.hover.background": {
    "value": "var(--cAMFKV)",
    "variable": "var(--cAMFKV)"
  },
  "colors.colorPalette.destructive.hover.text": {
    "value": "var(--jffvKC)",
    "variable": "var(--jffvKC)"
  },
  "colors.colorPalette.destructive.pressed.background": {
    "value": "var(--bIoeLR)",
    "variable": "var(--bIoeLR)"
  },
  "colors.colorPalette.destructive.pressed.text": {
    "value": "var(--hRnVsK)",
    "variable": "var(--hRnVsK)"
  },
  "colors.colorPalette.destructive.disabled.background": {
    "value": "var(--haorsH)",
    "variable": "var(--haorsH)"
  },
  "colors.colorPalette.destructive.disabled.text": {
    "value": "var(--eufKGQ)",
    "variable": "var(--eufKGQ)"
  },
  "colors.colorPalette.text.text": {
    "value": "var(--lcrPYU)",
    "variable": "var(--lcrPYU)"
  },
  "colors.colorPalette.text.hover.text": {
    "value": "var(--leUOcf)",
    "variable": "var(--leUOcf)"
  },
  "colors.colorPalette.text.pressed.text": {
    "value": "var(--OSgfj)",
    "variable": "var(--OSgfj)"
  },
  "colors.colorPalette.text.disabled.text": {
    "value": "var(--YWSzN)",
    "variable": "var(--YWSzN)"
  },
  "colors.colorPalette.buy.text": {
    "value": "var(--kVTJNz)",
    "variable": "var(--kVTJNz)"
  },
  "colors.colorPalette.buy.background": {
    "value": "var(--kqCOAE)",
    "variable": "var(--kqCOAE)"
  },
  "colors.colorPalette.buy.hover.background": {
    "value": "var(--iWCJgL)",
    "variable": "var(--iWCJgL)"
  },
  "colors.colorPalette.buy.pressed.background": {
    "value": "var(--fJlZrP)",
    "variable": "var(--fJlZrP)"
  },
  "colors.colorPalette.buy.disabled.background": {
    "value": "var(--SzdcJ)",
    "variable": "var(--SzdcJ)"
  },
  "colors.colorPalette.sell.text": {
    "value": "var(--elctVX)",
    "variable": "var(--elctVX)"
  },
  "colors.colorPalette.sell.background": {
    "value": "var(--KMcKU)",
    "variable": "var(--KMcKU)"
  },
  "colors.colorPalette.sell.hover.background": {
    "value": "var(--kTDMHb)",
    "variable": "var(--kTDMHb)"
  },
  "colors.colorPalette.sell.pressed.background": {
    "value": "var(--feMiYT)",
    "variable": "var(--feMiYT)"
  },
  "colors.colorPalette.sell.disabled.background": {
    "value": "var(--gEiXXF)",
    "variable": "var(--gEiXXF)"
  },
  "colors.colorPalette.backdrop": {
    "value": "var(--lmIneP)",
    "variable": "var(--lmIneP)"
  },
  "colors.colorPalette.text.title": {
    "value": "var(--iQtQAZ)",
    "variable": "var(--iQtQAZ)"
  },
  "colors.colorPalette.title": {
    "value": "var(--fXqUfh)",
    "variable": "var(--fXqUfh)"
  },
  "colors.colorPalette.text.description": {
    "value": "var(--clmuBb)",
    "variable": "var(--clmuBb)"
  },
  "colors.colorPalette.description": {
    "value": "var(--jUjaVb)",
    "variable": "var(--jUjaVb)"
  },
  "colors.colorPalette.background.checked": {
    "value": "var(--ccTWTR)",
    "variable": "var(--ccTWTR)"
  },
  "colors.colorPalette.checked": {
    "value": "var(--hqDsBW)",
    "variable": "var(--hqDsBW)"
  },
  "colors.colorPalette.background.hover": {
    "value": "var(--fwUfLA)",
    "variable": "var(--fwUfLA)"
  },
  "colors.colorPalette.background.disabled": {
    "value": "var(--eyiLBS)",
    "variable": "var(--eyiLBS)"
  },
  "colors.colorPalette.border.hover": {
    "value": "var(--eIQace)",
    "variable": "var(--eIQace)"
  },
  "colors.colorPalette.check": {
    "value": "var(--eVdlxr)",
    "variable": "var(--eVdlxr)"
  },
  "colors.colorPalette.check.disabled": {
    "value": "var(--NRMVK)",
    "variable": "var(--NRMVK)"
  },
  "colors.colorPalette.track.danger": {
    "value": "var(--cgVgis)",
    "variable": "var(--cgVgis)"
  },
  "colors.colorPalette.danger": {
    "value": "var(--LMIEy)",
    "variable": "var(--LMIEy)"
  },
  "colors.colorPalette.range": {
    "value": "var(--liJPLa)",
    "variable": "var(--liJPLa)"
  },
  "colors.colorPalette.range.danger": {
    "value": "var(--bnhQhw)",
    "variable": "var(--bnhQhw)"
  },
  "colors.colorPalette.askDepthBar.background": {
    "value": "var(--lLNjj)",
    "variable": "var(--lLNjj)"
  },
  "colors.colorPalette.askDepthBar.text": {
    "value": "var(--lOYcw)",
    "variable": "var(--lOYcw)"
  },
  "colors.colorPalette.askDepthBar.flash": {
    "value": "var(--cQMjMl)",
    "variable": "var(--cQMjMl)"
  },
  "colors.colorPalette.flash": {
    "value": "var(--kTXkfx)",
    "variable": "var(--kTXkfx)"
  },
  "colors.colorPalette.bidDepthBar.background": {
    "value": "var(--ddYtWR)",
    "variable": "var(--ddYtWR)"
  },
  "colors.colorPalette.bidDepthBar.text": {
    "value": "var(--ezdnUG)",
    "variable": "var(--ezdnUG)"
  },
  "colors.colorPalette.bidDepthBar.flash": {
    "value": "var(--dwhvTr)",
    "variable": "var(--dwhvTr)"
  },
  "colors.colorPalette.userOrderIndicator": {
    "value": "var(--cUjxVz)",
    "variable": "var(--cUjxVz)"
  },
  "colors.colorPalette.critical": {
    "value": "var(--kvcdfS)",
    "variable": "var(--kvcdfS)"
  },
  "colors.colorPalette.positiveText": {
    "value": "var(--dZXiWD)",
    "variable": "var(--dZXiWD)"
  },
  "colors.colorPalette.background.primary": {
    "value": "var(--iKuzZy)",
    "variable": "var(--iKuzZy)"
  },
  "colors.colorPalette.background.secondary": {
    "value": "var(--gfMmQQ)",
    "variable": "var(--gfMmQQ)"
  },
  "colors.colorPalette.background.neutral": {
    "value": "var(--edsMMf)",
    "variable": "var(--edsMMf)"
  },
  "colors.colorPalette.background.gold": {
    "value": "var(--cawmlm)",
    "variable": "var(--cawmlm)"
  },
  "colors.colorPalette.gold": {
    "value": "var(--ictBiB)",
    "variable": "var(--ictBiB)"
  },
  "colors.colorPalette.background.positive": {
    "value": "var(--kYhWt)",
    "variable": "var(--kYhWt)"
  },
  "colors.colorPalette.background.negative": {
    "value": "var(--ewEmAd)",
    "variable": "var(--ewEmAd)"
  },
  "colors.colorPalette.text.primary": {
    "value": "var(--jUjUKN)",
    "variable": "var(--jUjUKN)"
  },
  "colors.colorPalette.text.secondary": {
    "value": "var(--fucaer)",
    "variable": "var(--fucaer)"
  },
  "colors.colorPalette.text.neutral": {
    "value": "var(--gmjdhY)",
    "variable": "var(--gmjdhY)"
  },
  "colors.colorPalette.text.gold": {
    "value": "var(--jUCxnh)",
    "variable": "var(--jUCxnh)"
  },
  "colors.colorPalette.text.positive": {
    "value": "var(--dlRsci)",
    "variable": "var(--dlRsci)"
  },
  "colors.colorPalette.text.negative": {
    "value": "var(--kBxJkG)",
    "variable": "var(--kBxJkG)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar